// The setup wizard's calls to /api/org/me. The global axios interceptor adds the portal JWT.
import axios from 'axios';
import { shrinkImage } from '../../utils/shrinkImage';

const API = process.env.REACT_APP_API_URL || '';
const base = `${API}/api/org/me`;

export const getMe = () => axios.get(base).then((r) => r.data);
export const putMe = (body) => axios.put(base, body).then((r) => r.data);
// Logos and icons keep transparency and stop at 1600 px; photos are shrunk to 2400 px JPEG.
// Big phone photos and oversized logos are reduced here, so there is no practical size limit.
export const uploadImage = async (file, kind = 'logo') => {
  const isMark = kind === 'logo' || kind === 'icon';
  const prepared = await shrinkImage(file, isMark ? { maxEdge: 1600, keepAlpha: true } : { maxEdge: 2400 });
  const form = new FormData();
  form.append('file', prepared);
  return axios.post(`${base}/logo`, form, { params: { kind }, headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const getDocuments = () => axios.get(`${base}/documents`).then((r) => r.data);
export const getDocument = (kind) => axios.get(`${base}/documents/${kind}`).then((r) => r.data);
export const publishDocument = (kind, body) => axios.put(`${base}/documents/${kind}`, body).then((r) => r.data);
export const markStep = (step) => axios.post(`${base}/setup/step`, { step }).then((r) => r.data);
export const completeSetup = () => axios.post(`${base}/setup/complete`).then((r) => r.data);
export const getTeam = () => axios.get(`${base}/team`).then((r) => r.data);

// Stripe Connect (partner companies): status, hosted onboarding, go live, back to demo
export const getStripe = () => axios.get(`${base}/stripe`).then((r) => r.data);
export const startStripeOnboarding = () => axios.post(`${base}/stripe/onboard`).then((r) => r.data);
export const stripeGoLive = () => axios.post(`${base}/stripe/go-live`).then((r) => r.data);
export const stripeBackToDemo = () => axios.post(`${base}/stripe/demo`).then((r) => r.data);

export const errorMessage = (err, fallback) => err?.response?.data?.message || fallback;
